import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = 'spc_token';

// A hard timeout is essential here — without one, a stalled/slow connection leaves a request
// pending forever, which (combined with no-timeout retry loops) can make the app look frozen
// on the boot screen indefinitely instead of failing fast and falling back/retrying.
const api = axios.create({ baseURL: API_BASE, timeout: 12000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || '').filter(Boolean).join(' ') || 'Something went wrong';
  if (e?.code === 'ECONNABORTED' || e?.code === 'ERR_NETWORK') return 'Connection is slow or unavailable — please check your network and try again.';
  return e?.message || 'Something went wrong';
}

export default api;
